import produce from "immer";
import { React } from "xolabot-sdk";
import { store } from "../store";

const selectStyle = {
    display: "block",
    width: "80%",
    margin: "0 auto",
    height: 34,
    padding: "6px 12px",
    fontSize: 14,
    lineHeight: 1.42857143,
    color: "#555555",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: 2,
};

export const ChoicesAddon = ({ addon }) => {
    const { getState, setState } = store;
    const [choice, setChoice] = React.useState();

    const handleChange = (e) => {
        const { addons } = getState();
        setState({
            addons: produce(addons, (draft) => {
                draft[addon.id].quantity = e.target.value ? 1 : 0;
                draft[addon.id].configuration = addon.choices.find((choice) => choice.id === e.target.value);
                setChoice(e.target.value);
            }),
        });
    };

    return (
        <select type="select" name="select" style={selectStyle} onChange={handleChange} value={choice}>
            <option key={0}>Choose an option</option>
            {addon.choices.map((addonChoice) => {
                return (
                    <option key={addonChoice.id} value={addonChoice.id}>
                        {addonChoice.name}
                    </option>
                );
            })}
        </select>
    );
};
